export const appConfig = {
  startTabNumber: 0,
  startAdminTabNumber: 0,
  startNormalCabinetName:
    '0|t|150.00;191.00;60.40|t25.95;t126.91;f147.00;f167.10|d_2_c|3;4;5|2_3|0;*0;1;1;0|0_0|0|0|1_10',
  startCornerCabinetName:
    '2|t|200;120;100;60;60;40;60|f65.400;f130.800|r_1_c;l_3_c||2_2|*0;0;0|0_0|0|0|0_0',
  startCabinetProps: {
    width: 50,
    height: 70,
    depth: 30,
  },
  startDividers: [
    {
      type: 'none',
      top: 17.785,
      uuid: '9415a9b0-994b-4f18-89e6-b0185b3e34b6',
    },
  ],
  startDoors: [],
  startDrawers: [],
  startShelves: [],
  fractionDigits: 3,
  // startCabinetProps: {
  //     width: 100,
  //     height: 203.81,
  //     depth: 80
  // },
  // startDividers: [{
  //     type: "none",
  //     top: 100,
  //     uuid: "cee51db6-a99d-4a1a-b9d6-847b4f0c4e0c"
  // }],
  // startDoors: [
  //     {
  //         type: 'left',
  //         uuid: 'aecc5abd-6f1f-41b9-8c10-883bf03568aa',
  //         sectionNumber: 1,
  //         sectionHeight: 100,
  //         sectionY: 50,
  //         handleProps: {
  //             type: 'standard',
  //             position: 'center'
  //         }
  //     },
  //     // {
  //     //     type: 'double',
  //     //     uuid: 'f9fe523a-2291-411e-b103-269c3c8558ae',
  //     //     sectionNumber: 2,
  //     //     sectionHeight: 100,
  //     //     sectionY: -50,
  //     //     handleProps: {
  //     //         type: 'standard',
  //     //         position: 'center'
  //     //     }
  //     // }
  // ],
  // startDrawers: [],
  // startShelves: [
  //     {
  //         sectionNumber: 1,
  //         count: 1,
  //         sectionHeight: 100,
  //         sectionY: 50,
  //     },
  //     {
  //         sectionNumber: 2,
  //         count: 5,
  //         sectionHeight: 100,
  //         sectionY: -50,
  //     },
  // ]
}

export type ConfigsType = {
  doorConfig: {
    leftReveal: number
    rightReveal: number
    topReveal: number
    bottomReveal: number
    horizontalGap: number
    verticalGap: number
  }
  vGrooveConfig: {
    distance: number
    prof: number
    length: number
  }
  fivePiecesConfig: {
    pieceWidth: number
    centerThicknessDelta: number
  }
  drawerConfig: {
    minimumHeight: number
    minimumDepth: number
    boxBottomMaterialPrice: number
    boxLaborPrice: number[]
    boxDepthMargin: number
    boxDepths: number[]
    boxHeights: {
      value: number
      minimumTopMargin: number
      hardwareId: number
    }[]
    boxHeightBottomMargin: number
    boxWidthMargin: number
    boxSheetThickness: number
    handleRevalFromTop: number
  }

  handleConfig: {
    length: number
    diameter: number
    distFromEdge: number
    distFromVerticalEdge: number
    legDiameter: number
    legDist: number
    legLength: number
  }

  handlePositionFromGround: number

  thickness: number

  standardLegConfig: {
    boxWidth: number
    boxLength: number
    boxHeight: number
    littleCylinderRadius: number
    littleCylinderHeight: number
    bigCylinderRadius: number
    bigCylinderHeight: number
    sideReveal: number
    frontReveal: number
    backReveal: number
  }

  standard2LegConfig: {
    boxWidth: number
    boxLength: number
    boxHeight: number
    bigCylinderRadius: number
    bigCylinderHeight: number
    bigCylinderHeightTall: number
    separateLayerRadius: number
    separateLayerHeight: number
    littleCylinderRadius: number
    littleCylinderHeight: number
    littleSeparateLayerRadius: number
    littleSeparateLayerHeight: number
    littleSeparateLayerPosFromBottom: number
    sideReveal: number
    frontReveal: number
    backReveal: number
  }

  noToeKickLegConfig: {
    height: number
  }

  baseLegConfig: {
    height: number
    cutLength: number
  }

  separateBaseConfig: {
    sideMargin: number
    frontMargin: number
    platformHeight: number
    sheetThickness: number
  }

  minimumNonSplittedTopDepth: number
  minimumNonSplittedTopWidth: number
  splittedTopSheetWidth: number

  hingeBreakpoints: { array: string }
  companyOptionNames: { strValues: string }
  floorDistributorCompanies: { strValues: string }
}

export const doorConfig = {
  leftReveal: 1.1, //cm
  rightReveal: 1.1, //cm
  topReveal: 1.25, //cm
  bottomReveal: 1.25, //cm
  horizontalGap: 0.5, //cm
  verticalGap: 0.3, //cm
}

export const vGrooveConfig = {
  //cm
  distance: 5.715,
  prof: 0.508,
  length: 1.016,
}

export const fivePiecesConfig = {
  //cm
  pieceWidth: 10,
  centerThicknessDelta: 0.5,
}

export const drawerConfig = {
  //cm
  minimumHeight: 8.38,
  minimumDepth: 33.3,
  boxBottomMaterialPrice: 1.51 / 30.48 / 30.48, //$ per cm^2
  boxLaborPrice: [14, 15], //$
  boxDepthMargin: 2 + 1.3, // thickness + 1mm + 13mm constant
  boxDepths: [30, 35, 40, 45, 50, 55],
  boxHeights: [
    { value: 5.08, minimumTopMargin: 1.9, hardwareId: 91 },
    { value: 7.62, minimumTopMargin: 5.7, hardwareId: 92 },
    { value: 10.16, minimumTopMargin: 5.7, hardwareId: 93 },
    { value: 12.7, minimumTopMargin: 5.7, hardwareId: 175 },
    { value: 15.24, minimumTopMargin: 5.7, hardwareId: 94 },
    { value: 22.86, minimumTopMargin: 5.7, hardwareId: 95 },
  ],
  boxHeightBottomMargin: 1.4,
  boxWidthMargin: 1.25,
  boxSheetThickness: 1,
  handleRevalFromTop: 3.2,
}

export const handleConfig = {
  //cm
  length: 20.79625,
  diameter: 1.27,
  distFromEdge: 3.81,
  distFromVerticalEdge: 14.02,
  legDiameter: 1.26,
  legDist: 12.8,
  legLength: 2.54,
}

export const handlePositionFromGround = 100 //cm

export const thickness = 1.905

export const standardLegConfig = {
  boxWidth: 7.6,
  boxLength: 8.9,
  boxHeight: 2,
  littleCylinderRadius: 1.8,
  littleCylinderHeight: 8,
  bigCylinderRadius: 2.5,
  bigCylinderHeight: 2,
  sideReveal: 1,
  frontReveal: 1.5,
  backReveal: 1.5,
}

export const standard2LegConfig = {
  boxWidth: 7.6,
  boxLength: 8.9,
  boxHeight: 0.2,
  bigCylinderRadius: 2.5,
  bigCylinderHeight: 7.3,
  bigCylinderHeightTall: 12.3,
  separateLayerRadius: 2.7,
  separateLayerHeight: 1,
  littleCylinderRadius: 1.5,
  littleCylinderHeight: 8,
  littleSeparateLayerRadius: 1.7,
  littleSeparateLayerHeight: 0.5,
  littleSeparateLayerPosFromBottom: 1.8,
  sideReveal: 1,
  frontReveal: 1.5,
  backReveal: 1.5,
}

export const noToeKickLegConfig = {
  height: 12,
}

export const baseLegConfig = {
  height: 12,
  cutLength: 10,
}

export const separateBaseConfig = {
  sideMargin: 5,
  frontMargin: 10,
  platformHeight: 12,
  sheetThickness: 3,
}

export const minimumNonSplittedTopDepth = 50 //cm
export const minimumNonSplittedTopWidth = 50 //cm
export const splittedTopSheetWidth = 10 //cm

export const hingeBreakpoints = { array: '93.2, 162.7, 201.1, 242.7, 284.3' }

export const companyOptionNames = { strValues: 'buyButton' }
export const floorDistributorCompanies = { strValues: '' }

export const newDoorPullX = {
  '#B200-R203-S01': 3.3335,
  '#B200-R203-S04': 2.8575,
  '#B200-R401-S01': 3.3335,
  '#B200-R401-S04': 2.8575,
  '#B200-R500-S01': 3.016,
  '#B200-R500-S04': 2.54,
  '#B600-R102-S01': 3.3335,
  '#B600-R102-S04': 2.8575,
  '#B600-R100-S01': 3.016,
  '#B600-R100-S04': 2.54,
  '#B602-R102-S01': 3.3335,
  '#B602-R102-S04': 2.8575,
  '#B100-R000-S01': 3.3335,
  '#B100-R000-S04': 2.8575,
  fivePieces: 3.175,
  standard: 3.81,
}

export const newHandleConfigs = {
  legDist: {
    'DHP306-96': 9.6,
    'DHP465-192': 19.2,
    'DHP180-128': 12.8,
    'DHP504-192': 7.6,
  },
  legDiameter: {
    'DHP306-96': 1.7,
    'DHP465-192': 1.1,
    knob301: 2.9, //1.875"
    knob401: 2.5, //1.125"
  },
  distFromVerticalEdge: {
    standard: 6,
    arch: 6,
    'DHP306-96': 6,
    'DHP465-192': 6,
    'DHP180-128': 6,
    'DHP504-192': 0,
    knob301: 6,
    knob401: 6,
  },
}

export const doorPoolY = 7.62

export const drawerSlideProps = {
  standard: [
    { value: 25, hardwareId: 176 },
    { value: 30, hardwareId: 177 },
    { value: 35, hardwareId: 178 },
    { value: 40, hardwareId: 179 },
    { value: 45, hardwareId: 180 },
    { value: 50, hardwareId: 181 },
    { value: 55, hardwareId: 182 },
    { value: 60, hardwareId: 183 },
  ],
  soft: [
    { value: 30, hardwareId: 184 },
    { value: 35, hardwareId: 185 },
    { value: 40, hardwareId: 186 },
    { value: 45, hardwareId: 187 },
    { value: 50, hardwareId: 188 },
    { value: 55, hardwareId: 189 },
    { value: 60, hardwareId: 190 },
  ],
  under_mount: [
    { value: 31.9, hardwareId: 191 },
    { value: 38.9, hardwareId: 192 },
    { value: 46.5, hardwareId: 193 },
    { value: 54.1, hardwareId: 194 },
    { value: 61.8, hardwareId: 195 },
  ],
}

export const minDepthOfCabByDrawerSlideType = {
  standard: 28.5,
  soft: 33.5,
  under_mount: 35.6,
}

export const drawerSlideAllHardwareIds = [
  ...drawerSlideProps.standard.map((v) => v.hardwareId),
  ...drawerSlideProps.soft.map((v) => v.hardwareId),
  ...drawerSlideProps.under_mount.map((v) => v.hardwareId),
]
